<template>
    <video
        v-if="gif"
        ref="video"
        :poster="poster"
        playsinline
        preload="metadata"
        autoplay
        loop
        muted
        class="block w-full bg-gray-50 dark:bg-slate-700 border-0 rounded overflow-hidden"
        style="max-height: 480px"
    >
        <source :src="url"  type="video/mp4" />
    </video>
    <video
        v-else
        ref="video"
        :poster="poster"
        controls
        playsinline
        preload="metadata"
        :autoplay="autoplay"
        class="block w-full bg-gray-50 dark:bg-slate-700 border-0 rounded overflow-hidden"
        style="max-height: 480px"
    >
        <source :src="url"  type="video/mp4" />
    </video>
</template>
<script>
export default {
    props: [
        'url',
        'autoplay',
        'poster',
        'gif',
    ],
    mounted() {
        // if (!this.autoplay) {
        //     let video = this.$refs.video;
        //
        //     video.addEventListener("loadedmetadata", function () {
        //
        //         const hasAudio = video.mozHasAudio
        //             || Boolean(video.webkitAudioDecodedByteCount)
        //             || Boolean(video.audioTracks?.length)
        //
        //         if (!hasAudio) {
        //             // Если аудиодорожки нет, отключаем звук и устанавливаем зацикленный режим
        //             video.autoplay = true;
        //             video.muted = true;
        //             video.loop = true;
        //             video.controls = false;
        //         }
        //     });
        // }
    },
    data(){
        return {};
    }
}
</script>